import { useEffect, useState } from "react";
import api from "@/lib/api";
import { InfoTip } from "@/components/InfoTip";
import { CheckCircle2, Circle } from "lucide-react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "");

export function Timeline({ propertyId }) {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    let active = true;
    api.get(`/properties/${propertyId}/timeline`)
      .then(({ data }) => { if (active) setEvents(data.events); })
      .catch((e) => console.error("timeline load failed", e));
    return () => { active = false; };
  }, [propertyId]);

  if (!events) return null;
  const firstFuture = events.findIndex((e) => !e.done);

  return (
    <div className="mt-6 rounded-2xl border border-[#E2E8F0] bg-white p-5 sm:p-6" data-testid="property-timeline">
      <h2 className="font-heading text-xl font-semibold text-navy flex items-center gap-1.5">Property journey <InfoTip topic="propertyJourney" /></h2>
      <p className="mt-1 text-sm text-[#64748B]">Every milestone, built automatically from your activity.</p>

      <div className="mt-5 relative">
        <div className="absolute left-[11px] top-2 bottom-2 w-0.5 bg-navy/15" aria-hidden />
        <ul className="space-y-5">
          {events.map((e, i) => {
            const isNextStep = !e.done && i === firstFuture;
            return (
              <li key={e.key} data-testid={`timeline-event-${e.key}`} className="relative flex items-start gap-4">
                <span className={`relative z-10 grid place-items-center h-6 w-6 rounded-full shrink-0 ${
                  e.done ? "bg-amber text-navy" : "bg-[#F1F5F9] text-[#CBD5E1] border border-[#E2E8F0]"
                }`}>
                  {e.done ? <CheckCircle2 size={16} /> : <Circle size={12} />}
                </span>
                <div className="min-w-0 -mt-0.5">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className={`text-sm font-semibold ${e.done ? "text-navy" : "text-[#94A3B8]"}`}>{e.label}</p>
                    {e.done ? (
                      <span className="text-xs text-[#94A3B8]" data-testid={`timeline-date-${e.key}`}>{fmt(e.at)}</span>
                    ) : isNextStep ? (
                      <span className="text-[10px] font-semibold uppercase tracking-wider text-brand bg-brand/10 rounded-full px-2 py-0.5">Next step</span>
                    ) : null}
                  </div>
                  <p className={`text-xs mt-0.5 ${e.done ? "text-[#64748B]" : "text-[#CBD5E1]"}`}>{e.desc}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
